import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function PalletNavButDash( props ){
    //console.debug("RTS Break PalletNavButDash");

    const history = useNavigate();
    const {setCurFilter} = useSessionContext();

    function handlePalletsClick(e) {
        setCurFilter(null);
        props.setOpenDrawerFx(false);
        history("/PalletDashboard");
    }

    if(props.mode==="NavDrawer"){
        return (
            <>
            <ListItem button key="PalletDashboard" onClick={handlePalletsClick}>
                <ListItemText primary="Dashboard" />
            </ListItem>
            </>
        )
    }

    return (
        <>
        <Button
            key='PalletDashboard'
            onClick={handlePalletsClick}
            sx={{ my: 2, mx: 1, color: 'white', textTransform: 'unset' }}
        >
            Dashboard
        </Button>
        </>
    );
}



